<template>
  <div class="mechanism-container" @click="handleClick">
    <div class="logo">
      <img v-lazy="$global.imgUrl + mechanism.coverImg" v-if="mechanism.coverImg" alt="" />
      <img
        :src="require('@/assets/img/details/jigou.png')"
        alt=""
        v-else
      />
    </div>
    <div class="info">
      <div class="name">{{ mechanism.name }}</div>
      <div class="content">{{ mechanism.outline }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mechanism: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleClick() {
      let routeUrl = this.$router.resolve({
        name: "recommend",
        query: { id: this.mechanism.id, type: 2 },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.mechanism-container {
  display: flex;
  width: 890px;
  height: 168px;
  background: #ffffff;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  margin-bottom: 7px;
  align-items: center;
  border: 1px solid #A7C0EB;
  border-radius: 10px;
  &:hover {
    box-shadow: 0px 13px 15px 1px rgb(22 26 100 / 13%);
  }
  .logo {
    width: 117px;
    height: 116px;
    margin: 25px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    width: 686px;
    height: 55px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    .name {
      margin-top: -20px;
      font-size: 18px;
      font-weight: bold;
      color: #263d78;
      cursor: pointer;
    }
    .content {
      margin-top: 10px;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
